import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Group, Pagination as MPagination, Text } from "@mantine/core";
import { motion } from "framer-motion";

import { DEFAULT_PAGINATION, QP } from "@constants/index";

import { Pagination } from "@customTypes/index";

// todo: This component is now deprecated and should be removed after replacing all instances with the new table and pagination

interface CustomPaginationProps {
  table: any;
  tablePagination: Partial<Pagination>;
  otherParams?: Record<string, string>;
}

// todo: Move to utils folder
const addOtherQueryParams = (
  otherParams: Record<string, string> | undefined
) => {
  return Object.keys(otherParams ?? {}).length
    ? Object.entries(otherParams ?? {})
        .map(([key, value]) => {
          return `&${key}=${value}`;
        })
        .join("")
    : "";
};

export const CustomPagination = ({
  table,
  tablePagination,
  otherParams,
}: CustomPaginationProps) => {
  const { t } = useTranslation();

  // useLogger("tablePagination in Custom", [{ tablePagination }]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}>
      <Group justify="space-between" align="center" mt={"xl"} mb="8rem">
        <Text c="dimmed" fz={"sm"}>
          {t("displaying-x-rows", {
            paginatedRows: table.getPaginationRowModel().rows.length,
            totalRows: tablePagination.total,
          })}
        </Text>
        <MPagination
          size={"sm"}
          withEdges
          value={tablePagination.page}
          // Don't need this anymore
          // onChange={val => {
          //   setTablePagination(prev => ({ ...prev, page: val }));
          // }}
          getItemProps={page => ({
            component: Link,
            to: `?${QP.PAGE}=${page}${addOtherQueryParams(otherParams)}`,
          })}
          getControlProps={control => {
            if (control === "first") {
              return {
                component: Link,
                to: `?${QP.PAGE}=${
                  DEFAULT_PAGINATION.page
                }${addOtherQueryParams(otherParams)}`,
              };
            }

            if (control === "last") {
              return {
                component: Link,
                to: `?${QP.PAGE}=${
                  tablePagination.pageCount
                }${addOtherQueryParams(otherParams)}`,
              };
            }

            if (control === "next") {
              return {
                component: Link,
                to: `?${QP.PAGE}=${
                  tablePagination?.page &&
                  tablePagination?.pageCount &&
                  tablePagination.page < tablePagination.pageCount
                    ? tablePagination?.page + 1
                    : tablePagination.pageCount
                }${addOtherQueryParams(otherParams)}`,
              };
            }

            if (control === "previous") {
              return {
                component: Link,
                to: `?${QP.PAGE}=${
                  tablePagination?.page && tablePagination.page > 1
                    ? tablePagination?.page - 1
                    : 1
                }${addOtherQueryParams(otherParams)}`,
              };
            }

            return {};
          }}
          total={tablePagination?.pageCount || DEFAULT_PAGINATION.pageCount}
        />
      </Group>
    </motion.div>
  );
};
